import { Injectable } from '@angular/core';

@Injectable()
export class StorageService {
    private KEY_JWTACCESSTOKEN = 'YKCfRjvCAaCT9VfGZkCU2qjQg';
    private KEY_JWTREFRESHTOKEN = 'iephe4ka0cheewae3EGhiS4wo';
    private KEY_ROLES = 'p5wzzycbnxNBFFDrHGZE6v9FC';

    private CENTERDATE_KEY = 'S8Z3GJRLTW4s9k937Vc3QwjHP';

    private KEY_EMAILNOTCONFIRMED = 'U+EqB4c*@+RSf3}9JPnq%jN3k';
    private KEY_USER = 'K({RM3nkkC3`EAe.(3eAVh;!2';

    private getV(k: string) {
        if (localStorage.getItem(k) != null) {
            return localStorage.getItem(k);
        } else {
            return null;
        }
    }

    private saveV(k: string, value) {
        localStorage.setItem(k, value);
    }

    private clearV(k: string) {
        localStorage.removeItem(k);
    }

    getAuthorizationToken() {
        return 'Bearer ' + this.getJWTaccessToken();
    }

    getJWTaccessToken() {
        return this.getV(this.KEY_JWTACCESSTOKEN);
    }

    saveJWTaccessToken(jwt: string) {
        this.saveV(this.KEY_JWTACCESSTOKEN, jwt);
    }

    clearJWTaccessToken() {
        this.clearV(this.KEY_JWTACCESSTOKEN);
    }

    getJWTrefreshToken() {
        return this.getV(this.KEY_JWTREFRESHTOKEN);
    }

    saveJWTrefreshToken(jwt: string) {
        this.saveV(this.KEY_JWTREFRESHTOKEN, jwt);
    }

    clearJWTrefreshToken() {
        this.clearV(this.KEY_JWTREFRESHTOKEN);
    }

    getCenterDate() {
        return this.getV(this.CENTERDATE_KEY);
    }

    setCenterDate(date: string) {
        this.saveV(this.CENTERDATE_KEY, date);
    }

    getRoles(): string[] {
        return JSON.parse(this.getV(this.KEY_ROLES));
    }

    saveRoles(roles: string[]) {
        this.saveV(this.KEY_ROLES, JSON.stringify(roles));
    }

    clearRoles() {
        this.clearV(this.KEY_ROLES);
    }

    clearAll() {
        localStorage.clear();
        sessionStorage.clear();
    }

    saveEmailNotConfirmed() {
        this.saveV(this.KEY_EMAILNOTCONFIRMED, 'Not Confirmed');
    }

    getEmailNotConfirmed() {
        return this.getV(this.KEY_EMAILNOTCONFIRMED);
    }

    clearEmailNotConfirmed() {
        this.clearV(this.KEY_EMAILNOTCONFIRMED);
    }

    getUser() {
        return this.getV(this.KEY_USER);
    }

    saveUser(user: string) {
        this.saveV(this.KEY_USER, user);
    }

    clearUser() {
        this.clearV(this.KEY_USER);
    }
}
